import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import * as cls from "./calendarLessonDetail.module.scss";
import { useSelector } from "react-redux";
import { StudentService } from "../studentService";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
import { ErrataView } from "../../../personal-studio-components/service";

export default function CalendarLessonDetail() {
  const [calendarLessonDetail, setCalendarLessonDetail] = useState(null);
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [legend, setLegend] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  async function getCalendarLessonDetail() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/widget/calendar_lesson_detail",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      await StudentService.send(request, (response) => {
        if (response) {
          setErrorMessage(response);
          if (!response.errors) {
            setCalendarLessonDetail(response);
            const res = Object.entries(response.columns).map((col) => {
              const obj = { root_lesson_group_id: col[0], name: col[1] };
              let class_name = "";
              switch (obj.root_lesson_group_id) {
                case "4":
                  class_name = cls.session;
                  break;
                case "6":
                  class_name = cls.certificate;
                  break;
                case "8":
                  class_name = cls.practice;
                  break;
                case "13":
                  class_name = cls.holidays;
                  break;
                case "10000":
                  class_name = cls.autofill;
                default:
                  break;
              }
              return { ...obj, class_name };
            });
            setLegend(res);
          } else {
            const errorEvent = new ErrorEvent("error", {
              error: response,
            });
            window.dispatchEvent(errorEvent);
            return;
          }
        }
      });
    }
  }
  useEffect(() => {
    getCalendarLessonDetail();
  }, [access_token, contractId]);

  function getClassNameForDate(date) {
    let class_name = "";
    for (const row of calendarLessonDetail?.rows || []) {
      const beginDate = new Date(row.begin_date);
      const endDate = new Date(row.end_date);
      date.setHours(0, 0, 0, 0);
      beginDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      if (date >= beginDate && date <= endDate) {
        if (row.root_lesson_group_id === 10000) {
          return cls.autofill; // Приоритет у автозаписи если есть совдадения по датам с другими root_lesson_group_id
        } else {
          switch (row.root_lesson_group_id) {
            case 4:
              class_name = cls.session;
              break;
            case 6:
              class_name = cls.certificate;
              break;
            case 8:
              class_name = cls.practice;
              break;
            case 13:
              class_name = cls.holidays;
              break;
            default:
              break;
          }
        }
      }
    }

    return class_name;
  }

  function tileClassName({ date, view }) {
    if (view === "month") {
      const today = new Date();
      if (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      ) {
        return; // отключаем заливку у текущей даты
      }
    }
    return getClassNameForDate(date); //стили дат по легенде
  }

  function tileContent({ date }) {
    let content = null;
    for (const row of calendarLessonDetail?.rows || []) {
      const beginDate = new Date(row.begin_date);
      const endDate = new Date(row.end_date);
      if (date >= beginDate && date <= endDate) {
        content = <span title={row.lesson_group_full_name}></span>;
        break;
      }
    }
    return content;
  }
  if (errorMessage.errors) {
    return (
      <>
        {errorMessage.error_type === "info" ? (
          <ErrataViewInfo errata={errorMessage} />
        ) : (
          <ErrataView errata={errorMessage} />
        )}
      </>
    );
  }
  if (calendarLessonDetail)
    return (
      <div className={cls.calendar_container}>
        <Calendar tileClassName={tileClassName} tileContent={tileContent} />
        <div className={cls.calendar_footer_container}>
          {legend.map((col) => (
            <div style={{ display: "flex", width: "50%" }}>
              <div className={`${cls.color_cube} ${col.class_name}`}>
                <div className={cls.color_info}>{col.name}</div>
              </div>
            </div>
          ))}

          {/* <div className={cls.calendar_footer_box}>
          <div>
            <div className={`${cls.color_cube} ${cls.session}`}>
              <div className={cls.color_info}>Сессия</div>
            </div>
          </div>
          <div>
            <div className={`${cls.color_cube} ${cls.practice}`}>
              <div className={cls.color_info}>Практика</div>
            </div>
          </div>
        </div>
        <div className={cls.calendar_footer_box}>
          <div>
            <div className={`${cls.color_cube} ${cls.autofill}`}>
              <div className={cls.color_info}>Автозапись</div>
            </div>
          </div>
          <div>
            <div className={`${cls.color_cube} ${cls.certificate}`}>
              <div className={cls.color_info}>Итоговая аттестация</div>
            </div>
          </div>
          <div>
            <div className={`${cls.color_cube} ${cls.holidays}`}>
              <div className={cls.color_info}>Каникулы</div>
            </div>
          </div>
        </div> */}
        </div>
      </div>
    );
}
